import React from 'react';

const ArrowNeutral = ({color = 'grey'}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="4" y1="12" x2="20" y2="12" stroke={color} strokeWidth="2" />
  </svg>
);

export default ArrowNeutral;
